var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddVisionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6 2C2.24189 2 2 2.2751 2 2.55556V10.3333C2 10.6138 2.24189 10.8889 2.6 10.8889H15.4C15.7581 10.8889 16 10.6138 16 10.3333V2.55556C16 2.2751 15.7581 2 15.4 2H2.6ZM10 12.8889H15.4C16.8092 12.8889 18 11.7711 18 10.3333V2.55556C18 1.11779 16.8092 0 15.4 0H2.6C1.1908 0 0 1.11779 0 2.55556V10.3333C0 11.7711 1.1908 12.8889 2.6 12.8889H8V14H5.8C5.24771 14 4.8 14.4477 4.8 15C4.8 15.5523 5.24771 16 5.8 16H12.2C12.7523 16 13.2 15.5523 13.2 15C13.2 14.4477 12.7523 14 12.2 14H10V12.8889ZM9 2.625C9.55229 2.625 10 3.07272 10 3.625V5.44444H11.6667C12.219 5.44444 12.6667 5.89216 12.6667 6.44444C12.6667 6.99673 12.219 7.44444 11.6667 7.44444H10V9.3125C10 9.86479 9.55229 10.3125 9 10.3125C8.44772 10.3125 8 9.86479 8 9.3125V7.44444H6.33333C5.78105 7.44444 5.33333 6.99673 5.33333 6.44444C5.33333 5.89216 5.78105 5.44444 6.33333 5.44444H8V3.625C8 3.07272 8.44772 2.625 9 2.625Z",
    fill: "#8B97F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVisionIcon);
export default __webpack_public_path__ + "static/media/addVisionIcon.6175398cd653408bc2f8c9a5d98740a9.svg";
export { ForwardRef as ReactComponent };